import * as React from 'react';
import { cn } from '../../lib/utils';

// Define Props including the optional icon and error
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, icon, error, ...props }, ref) => {
  return (
    <div className='relative'>
      <div className='relative flex items-center w-full'>
        <input
          type={type}
          data-slot='input'
          className={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            error
              ? 'border-destructive focus-visible:ring-destructive/50'
              : 'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            icon ? 'pr-10' : '',
            className,
          )}
          aria-invalid={!!error}
          ref={ref}
          {...props}
        />
        {icon && <div className='absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none'>{icon}</div>}
      </div>
      {error && <p className='text-sm text-destructive mt-1'>{error}</p>}
    </div>
  );
});
Input.displayName = 'Input';

export { Input };
